var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.biz === 'list')?_c('span',{class:['inline-block', _vm.computedClass]},[_vm._v(_vm._s(_vm.LEAVE_STATUS_TEXT[_vm.status]))]):_c('i',{staticClass:"font-120 iconfont",style:({ color: _vm.computedClass.color }),domProps:{"innerHTML":_vm._s(_vm.computedClass.icon)}})
}
var staticRenderFns = []

export { render, staticRenderFns }